import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=ac50dee6&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=ac50dee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac50dee6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ac50dee6')) {
      api.createRecord('ac50dee6', component.options)
    } else {
      api.reload('ac50dee6', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=ac50dee6&scoped=true&", function () {
      api.rerender('ac50dee6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/leaderboard/campaign/Edit.vue"
export default component.exports